import React from "react";
import { cn } from "@/lib/utils";

interface JelloShotLogoProps {
  className?: string;
}

export const JelloShotLogo: React.FC<JelloShotLogoProps> = ({ className }) => {
  return (
    <img
      src="/jelloshot-logo.svg?v=lockup"
      alt="jelloshot"
      width={969}
      height={230}
      className={cn("h-8 w-auto sm:h-9", className)}
    />
  );
};
